// Mock data and shared helpers for the public landing page

export const mockContactSubmit = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({ success: true, message: 'Consulta enviada exitosamente' });
    }, 1000);
  });
};

export const whatsappNumbers = {
  primary: '+54 9 11 3561-0244',
  secondary: '+54 9 11 4083-9106'
};

export const toDisplay = (phoneNumber) => phoneNumber.replace('+54 9 ', '');

// Primary business WhatsApp (used by floating button and generic CTAs)
export const WA_MAIN = whatsappNumbers.secondary;

export const getTelLink = (phoneNumber) => `tel:+${phoneNumber.replace(/[^0-9]/g, '')}`;

export const INSTAGRAM_URL = 'https://www.instagram.com/sampellegrini.jaliff/';
export const INSTAGRAM_HANDLE = '@sampellegrini.jaliff';

export const GOOGLE_REVIEWS_URL = 'https://maps.app.goo.gl/HS88awbVTXE9eKwV9?g_st=awb';

export const GOOGLE_MAPS_URL =
  'https://www.google.com/maps/place/Estudio+Juridico+Ben%C3%ADtez+Sampellegrini,+Jaliff+%26+Asoc./@-34.6782894,-58.5614538,17z/data=!4m14!1m7!3m6!1s0x95bcc7e974f5e98d:0x181ac70f57fc155c!2sEstudio+Juridico+Ben%C3%ADtez+Sampellegrini,+Jaliff+%26+Asoc.!8m2!3d-34.6782894!4d-58.5588735!16s%2Fg%2F11vz8wrcbp!3m5!1s0x95bcc7e974f5e98d:0x181ac70f57fc155c!8m2!3d-34.6782894!4d-58.5588735!16s%2Fg%2F11vz8wrcbp?entry=ttu&g_ep=EgoyMDI2MDUyNi4wIKXMDSoASAFQAw%3D%3D';

export const CONTACT_ADDRESS = 'Perú 2385, San Justo';
export const CONTACT_HOURS = 'Lunes a viernes de 10:00 a 15:30 hs';

export const getWhatsAppLink = (phoneNumber, message = '') => {
  const cleanNumber = phoneNumber.replace(/[^0-9]/g, '');
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodedMessage}` : ''}`;
};

/**
 * Fires conversion tracking events for a WhatsApp click.
 * - Google Analytics 4 (gtag): fires 'generate_lead' + 'click_whatsapp'
 * - Meta Pixel (fbq): fires 'Contact' and 'Lead' if installed
 * - dataLayer push for Google Tag Manager compatibility
 * Safe no-op when none of the trackers are loaded.
 */
export const ADS_CONVERSION_LEAD = 'AW-16546978179/wKTMCIbD9qMdEIOzm9I9';
export const ADS_CONVERSION_WHATSAPP = 'AW-16546978179/o6PKCInD9qMdEIOzm9I9';

export const ADS_CONVERSION_PHONE = 'AW-16546978179/QO2pCL7Am68dEIOzm9I9';

export const trackAdsConversion = (sendTo, extra = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', { send_to: sendTo, ...extra });
    }
  } catch (err) {
    console.warn('trackAdsConversion error:', err);
  }
};

export const trackPhoneClick = () => {
  trackAdsConversion(ADS_CONVERSION_PHONE, { value: 1.0, currency: 'ARS' });
};

export const trackWhatsAppClick = (label = 'whatsapp') => {
  try {
    if (typeof window === 'undefined') return;

    trackAdsConversion(ADS_CONVERSION_WHATSAPP);

    // Google Analytics 4
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', {
        event_category: 'engagement',
        event_label: label,
        method: 'whatsapp',
        value: 1
      });
      window.gtag('event', 'click_whatsapp', {
        event_category: 'engagement',
        event_label: label
      });
    }

    // Google Tag Manager dataLayer (works even without gtag)
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'whatsapp_click',
        action: 'whatsapp-click',
        label
      });
    }

    // Meta Pixel (if ever installed)
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Contact');
      window.fbq('track', 'Lead');
    }
  } catch (err) {
    // Tracking must never break UX
    console.warn('trackWhatsAppClick error:', err);
  }
};

/**
 * Opens WhatsApp with the given phone + message and fires tracking in one step.
 */
export const openWhatsApp = (phoneNumber, message = '', label = 'whatsapp') => {
  trackWhatsAppClick(label);
  const url = getWhatsAppLink(phoneNumber, message);
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
